<template>
  <div class="card-form">
    <PageMain
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditPage="openEditPage"
      @onShelve="onShelve"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
      >
        <b-button
          v-if="allow('A')"
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="openEditPage({ pageType: 'add' })"
        >
          <b-icon-plus></b-icon-plus>
          {{ $l('INDEX.btn_add') || '新增' }}
        </b-button>

        <el-badge
          v-if="allow('P')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('P')"
            size="sm"
            style="margin-left:10px"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="onPrint"
          >
            <b-icon-tag></b-icon-tag>
            {{ $l('btn_print') || '标签打印' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
        <el-badge
          v-if="allow('P')"
          :value="checkedRowCount"
          :hidden="!checkedRowCount"
          class="clearable-button"
          :class="{ clearable: !!checkedRowCount }"
        >
          <b-button
            v-if="allow('P')"
            size="sm"
            style="margin-left:10px"
            variant="outline-success"
            :disabled="!checkedRowCount"
            @click="onShelveBatch"
          >
            {{ $l('btn_shelve_sample') || '样品上架' }}
            <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
          </b-button>
        </el-badge>
      </PageHeader>

      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <el-dialog
      append-to-body
      :title="$l('dialog_title_choose_location_no') || '选择上架库位'"
      :visible.sync="visibleShelve"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
    >
      <el-form
        ref="form"
        :model="formData"
        :rules="rules"
        label-position="left"
        label-width="90px"
      >
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_lable_locationNo') || '库位号'"
              prop="locationNo"
            >
              <el-cascader
                :options="treeData"
                :props="{
                  emitPath: false,
                  checkStrictly: true,
                  value: 'code',
                  label: 'label',
                }"
                size="small"
                ref="cascaderFunctionTreeRef"
                v-model="formData.locationCode"
                @change="calculateClassLevel"
                clearable
                style="width: 100%"
              >
                <template slot-scope="{ node, data }">
                  <span>{{ data.label }}</span>
                  <span v-if="!node.isLeaf">
                    ({{ data.children.length }})
                  </span>
                </template>
              </el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="submitShelve" type="primary" size="small">
          {{ $l('btn_shelve') || '上架' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import PageHeader from './header'
import PageMain from './main.vue'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader },
  data() {
    return {
      usePage: true,
      visibleShelve: false,
      formData: {
        locationNo: '',
        locationCode: '',
        level: 0,
      },
      rules: {
        locationNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
      treeData: [],
      dataList: [],
      checkedRows: [],
    }
  },
  computed: {
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .ecomAmzSampleListApi({ ...form, ...this.page })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    calculateClassLevel() {
      const node = this.$refs.cascaderFunctionTreeRef.getCheckedNodes()
      if (node && node.length) {
        this.formData.locationNo = node[0].data.locationNo
        this.formData.level = node[0].data.level
      }
    },
    async onShelveBatch() {
      const codes = this.checkedRows.map((e) => e.amzSampleCode)
      this.onShelve(codes)
    },
    async onShelve(codes) {
      const res = await this.$api.warehouseTreeApi()
      this.treeData = res.body.data
      this.visibleShelve = true
      this.dataList = [...codes]
    },
    onPrint() {
      const codes = this.checkedRows.map((e) => e.amzSampleCode)
      if (!codes?.length) {
        this.$message({
          showClose: true,
          message: '请选择需要打印的样品',
          type: 'warning',
        })
        return
      }
      let data = {
        codes,
      }
      let fileName
      if (codes.length == 1) {
        fileName = `AMZ样品标签_${this.checkedRows[0].amzSampleNo}_`
      } else {
        fileName = `AMZ样品标签(多个)`
      }
      this.$api.globalExportData('/ecom/amz/sample/print', data, fileName)
    },
    async submitShelve() {
      const result = await validate.formValidate([this.$refs.form])
      if (this.formData.level == '0') {
        this.$message.warning(
          this.$l('dialog_confirm_msg') || '不可将顶级展厅设置为库位！'
        )
        return
      }
      if (!result) {
        return
      }

      await this.$api
        .ecomAmzSampleShelveApi({
          locationNo: this.formData.locationNo,
          codes: this.dataList,
        })
        .then(async () => {
          this.$message.success(this.$l('INDEX.tips_set_ok') || '设置成功！')
          this.close()
          this.reload()
        })
        .catch(() => {})
    },
    close() {
      this.visibleShelve = false
      this.formData = {
        locationNo: '',
        locationCode: '',
        level: 0,
      }
      this.dataList = []
      this.clearCheckboxRow()
    },
    openEditPage({ pageType, params = {}, query = {} }) {
      this.$router.push({
        name: 'ecom-awsSample-sampleInfo-detail',
        params: { ...params, pageType },
        query,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
